export const CATEGORY_HIGHLIGHTS = {
  Venues: {
    intro: 'A wedding venue sets the tone for everything that follows, from the light in your photographs to the way the evening unfolds.',
    points: ['Ceremony and reception spaces, indoors and out', 'Wet-weather and summer-heat alternatives', 'Catering, bar and coordination packages', 'Guest capacity, parking and transport access'],
  },
  Photography: {
    intro: 'Your photographs are the only part of the wedding that grows more valuable with time, so chemistry with your photographer matters.',
    points: ['Full-day and half-day coverage', 'Editorial, documentary and fine-art styles', 'Engagement sessions and golden-hour portraits', 'Albums, prints and online galleries'],
  },
  Catering: {
    intro: 'In Malta the food is a love language, and a great caterer turns a reception into a feast guests talk about for years.',
    points: ['Plated, buffet and family-style menus', 'Canapé receptions and late-night bites', 'Drinks packages and signature cocktails', 'Tastings, dietary planning and service staff'],
  },
  Fashion: {
    intro: 'The right dress or suit should feel like you on your most confident day, and fit flawlessly from the aisle to the dancefloor.',
    points: ['Bridal, groom and bridal-party collections', 'Appointments, fittings and alterations', 'Accessories and finishing touches', 'Lead times for ordering and made to measure'],
  },
  Beauty: {
    intro: 'Bridal beauty is about looking like the best version of yourself, in person and in every photograph, from first look to last dance.',
    points: ['Trials ahead of the wedding day', 'On-location styling for the bridal party', 'Long-wear, heat-proof techniques for Malta', 'Hair extensions, skin prep and touch-up kits'],
  },
  Floristry: {
    intro: 'Flowers carry your colour palette through the whole day, from the bouquet to the last candle on the table.',
    points: ['Bouquets, buttonholes and flower crowns', 'Ceremony arches and aisle styling', 'Table centrepieces and installations', 'Seasonal Mediterranean blooms and foliage'],
  },
  Entertainment: {
    intro: 'Entertainment is what guests remember when the flowers have faded: the first dance, the full floor, the moment everyone sang along.',
    points: ['Ceremony and aperitivo music', 'Live bands, DJs and after-party sets', 'Photo booths, fireworks and special moments', 'Sound, lighting and venue curfews'],
  },
  Transport: {
    intro: 'Arriving in style, and getting every guest home safely, is one of those details that makes a wedding feel effortless.',
    points: ['Bridal cars, vintage and classic', 'Guest coaches and shuttles', 'Timings between church, venue and hotels', 'Decoration, ribbons and chauffeur service'],
  },
  Décor: {
    intro: 'Styling and décor are where your theme comes to life: linens, lighting, furniture and the details that photograph beautifully.',
    points: ['Tablescapes, linens and tableware', 'Lighting, festoons and candles', 'Furniture, lounges and signage', 'Full styling concepts and set-up'],
  },
  'Home & Lifestyle': {
    intro: 'The wedding is one day; the home you build together is forever. These partners help newlyweds furnish and style their first chapter.',
    points: ['Furniture and interiors for first homes', 'Gift lists and wedding registries', 'Kitchen, living and bedroom collections', 'Design consultations and delivery'],
  },
  Services: {
    intro: 'The behind-the-scenes partners who make wedding planning, and married life, run smoothly.',
    points: ['Specialist advice and consultations', 'Planning and legal practicalities', 'Products and services for couples', 'Trusted by I DO readers'],
  },
};

export const getHighlights = (category) => CATEGORY_HIGHLIGHTS[category] || CATEGORY_HIGHLIGHTS.Services;
